export const maxlengthContentEditable = () => {
  var editableElements = document.querySelectorAll(
    'div[contenteditable="true"]'
  );

  var clipboardEvents = ["copy", "paste", "cut"];
  var keyboardEvents = [
    "keyup",
    "keypress",
    "keydown",
    "blur",
    "change",
    "compositionstart",
    "compositionend",
  ];

  Array.from(editableElements).forEach(function (element) {
    clipboardEvents.forEach(function (clipboardEvent) {
      element.addEventListener(clipboardEvent, clipboardEventHandler);
    });
    keyboardEvents.forEach(function (keyboardEvent) {
      element.addEventListener(keyboardEvent, generalEventKeyHandler);
    });
  });

  function clipboardEventHandler(event) {
    // IE
    if (window.clipboardData) {
      if (
        window.clipboardData.getData("Text").length + this.textContent.length >
        this.dataset.maxLength
      ) {
        event.preventDefault();
      }
    }
    // Chrome , Firefox
    if (event.clipboardData) {
      if (
        event.clipboardData.getData("Text").length + this.textContent.length >
          this.dataset.maxLength &&
        event.keyCode !== 8
      ) {
        event.preventDefault();
      }
    }
  }
  function getSelectPos(obj) {
    var range = window.getSelection(); //创建range
    range.selectAllChildren(obj); //range 选择obj下所有子内容
    range.collapseToEnd(); //光标移至最后
  }
  function generalEventKeyHandler(event) {
    if (
      this.dataset.maxLength &&
      Number(this.textContent.length) >= Number(this.dataset.maxLength) &&
      !isAllowedKeyCode(event)
    ) {
      // 处理输入中文时的逻辑
      if (event.type == "compositionend") {
        let triggerValue = setTriggerValue(
          true,
          event.target,
          event.target.innerText,
          this.dataset.maxLength
        );
        event.target.innerText = triggerValue;
        getSelectPos(event.target);
      }
      event.preventDefault();
    }
  }
  function setTriggerValue(isCursorInEnd, preValue, triggerValue, maxLeng) {
    let newTriggerValue = triggerValue;
    if (isCursorInEnd) {
      // 光标在尾部，直接截断
      newTriggerValue = fixEmojiLength(triggerValue, maxLeng);
    } else if (
      [...(preValue || "")].length < triggerValue.length &&
      [...(triggerValue || "")].length > maxLeng
    ) {
      // 光标在中间，如果最后的值超过最大值，则采用原先的值
      newTriggerValue = preValue;
    }
    return newTriggerValue;
  }
  function fixEmojiLength(value, maxLength) {
    return value.slice(0, maxLength);
  }
  function isAllowedKeyCode(event) {
    return (
      event.keyCode === 8 ||
      event.keyCode === 38 ||
      event.keyCode === 39 ||
      event.keyCode === 37 ||
      event.keyCode === 40
    );
  }
};
